import { valuesSelectors } from '../values';

import getActiveFilters from './getActiveFilters';
import getFiltersAsCayenneParams from './getFiltersAsCayenneParams';
import getFiltersAsQueryParams from './getFiltersAsQueryParams';

const getFilterState = (state) => state.playersAndTeams.filter;

export default {
    ...valuesSelectors,
    getActiveFilters,
    getFiltersAsCayenneParams,
    getFiltersAsQueryParams,
    getFilterState,
};
